/// <reference path="../../../../combination-chart/combination-chart.module.ts" />
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import { HttpClient } from '@angular/common/http';
import { BarserviceService } from '../../barservice.service';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { SignificanceService } from 'src/app/common/services/significance.service';
// import { url } from 'inspector';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import Stock from 'highcharts/modules/stock';
import { Observable, Subscription } from 'rxjs';
import * as _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { zIndex } from 'html2canvas/dist/types/css/property-descriptors/z-index';
Stock(Highcharts);
@Component({
  selector: 'app-barchart14-custom',
  templateUrl: './barchart14.component.html', 
  styleUrls: ['./barchart14.component.scss']
})
export class Barchart14ComponentCustom implements OnInit {
  chart: any;
  event: any;
  datalabel: any = false;
  barChartData: any;
  Highcharts: typeof Highcharts = Highcharts;
  seriesData: any = [];
  changeValue: any;
  properties: any;
  changeValueSeries: any;
  significance: any;
  sampleSize: any;
  data: any;
  defaultCategories1: any;
  max: any;
  maxBarValue = 0;
  min: any;
  public seriesData1: any[] = [];
  jsonData: any;
  categories: any;
  labels: any;
  significance2: any;
  categoryImages: any;
  maxDataPoints: any = 8;
  userselectedchartdata: any;
  hasCustomMetricIndex = false;
  hasCustomMetricSignificance = false;
  hasCustomMetricPercentage = false;

  //parameters from snapshot-chrtparent
  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any="24em";
  @Input() isOutput: any;
  constructor(private http: HttpClient, private _configService: SnapshotService, private route: ActivatedRoute, private barService: BarserviceService, private _customSnapshotService: CustomsnapshotService, private significanceService: SignificanceService) { }
  //   ngOnInit(): void {  
  //     this.http.get<any>('assets/Data/barData.json').subscribe((data: any) => {
  //       this.jsonData = data;
  //       this.data = data[0];
  //       this.barChartData = data[0]["data"];
  //       this.properties = data[0]["properties"][0];
  //       this.properties.decimalRoundOff = 2;
  //       this.route.paramMap.subscribe((params) => {
  //         const userData = history.state.userData;
  //         this.userselectedchartdata = userData; // Use the userData object as needed
  //         if (this.userselectedchartdata?.widgetEditSelection) {
  //           if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
  //             this.properties = JSON.parse(this.userselectedchartdata.widgetEditSelection?.customizationProperties);
  //           }
  //         }
  //       });
  //       this.getData(this.jsonData, this.properties.datalabelStyle == "ls");
  //       this.getBarChart('chart-container'+this.id, this.seriesData1, this.properties);
  //     });
  //   }
  private subscriptions: Subscription = new Subscription();
  private _initDone = false;
  significanceValue: any = "None";
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  DefaultConfidenceLevel: any = "";
  configuredProperties:any;
  ngOnInit(): void {
    if (this.isOutput) {
      this.configuredProperties=JSON.parse(this.customData.customizationProperties);
      this.customData = this.customData.metric[0];
      this.applyCustomMetricExtensions();
      if(this.configuredProperties?.sort=="default")this.customData.metric_value.sort((a: any, b: any) => a.selectOrder - b.selectOrder);
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe(value => {
          this.DefaultConfidenceLevel = value;
          if (this._initDone) this.updateSig();
        }));
      // this.subscriptions.add(
      //   this._configService.page2ToggleSubject.subscribe((page: any) => {
      //     this.layoutNumber = page;
      //     Barchart14Component.y = page;
      //   }));


      // this.maxDataPoints = this.layoutNumber == 2 ? 12 : this.popUp ? 10 : this.maxDataPoints;
      this.subscriptions.add(
        this._configService.significanceValue.subscribe(value => {
          this.significanceValue = value;
          if (this._initDone) this.updateSig();
        }));
      // Both BehaviorSubjects have now emitted synchronously; mark init done
      // and do a single explicit first render.
      this._initDone = true;
      this.updateSig();
    }
    else {
      this.http.get<any>('assets/Data/barData.json').subscribe((data: any) => {
        this.jsonData = data;
        this.data = data[0];
        this.barChartData = data[0]["data"];
        this.properties = data[0]["properties"][0];
        this.properties.decimalRoundOff = 2;
        this.properties.showLegend=true;
        this.route.paramMap.subscribe((params) => {
          const userData = history.state.userData;
          this.userselectedchartdata = userData; // Use the userData object as needed
          if (this.userselectedchartdata?.widgetEditSelection) {
            if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
              this.properties = JSON.parse(this.userselectedchartdata.widgetEditSelection?.customizationProperties);
            }
          }
        });
        this.getData(this.jsonData, this.properties.datalabelStyle == "ls");
        this.getBarChart('chart-container' + this.id, this.seriesData1, this.properties);
      });
    }
  }
private applyCustomMetricExtensions(): void {

    const metrics = this.customData?.metric_value || [];

    this.hasCustomMetricIndex = false;
    this.hasCustomMetricSignificance = false;
    this.hasCustomMetricPercentage = false;

    metrics.forEach((metric: any) => {

      const extensions = metric.extensionOptions || [];

      if (
        extensions.some((e: any) =>
          e.id === 'index' && e.selected
        )
      ) {
        this.hasCustomMetricIndex = true;
      }

      if (
        extensions.some((e: any) =>
          e.id === 'significance' && e.selected
        )
      ) {
        this.hasCustomMetricSignificance = true;
      }

      if (
        extensions.some((e: any) =>
          e.id === 'percentageSymbol' && e.selected
        )
      ) {
        this.hasCustomMetricPercentage = true;
      }
    });


  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customData'] && !changes['customData'].firstChange) {
      if (this.isOutput) {
        this.configuredProperties = JSON.parse(this.customData.customizationProperties);
        this.customData = this.customData.metric[0];
        this.applyCustomMetricExtensions();
        if (this.configuredProperties?.sort == 'default') this.customData.metric_value.sort((a: any, b: any) => a.selectOrder - b.selectOrder);
        this.updateSig();
      }
    }
  }

  chartMainData: any = [];
  private _updateSigTimer: any = null;
  updateSig() {
    // Debounce: if multiple calls arrive in quick succession (e.g. two
    // BehaviorSubjects emitting, or ngOnChanges + subscription), only
    // execute the LAST one so we always render the freshest state.
    if (this._updateSigTimer) {
      clearTimeout(this._updateSigTimer);
    }
    this._updateSigTimer = setTimeout(() => {
      this._updateSigTimer = null;
      this._doUpdateSig();
    }, 30);
  }

  private _doUpdateSig() {
    this.updateSigSub?.unsubscribe();

    // Snapshot ALL values at call-time so async completion cannot see stale state
    const capturedCustomData = this.customData;
    const capturedConfiguredProperties = this.configuredProperties ? { ...this.configuredProperties } : undefined;
    const capturedSignificanceValue = this.significanceValue;
    const capturedDefaultConfidenceLevel = this.DefaultConfidenceLevel;

    const doRender = () => {
      this.properties = capturedConfiguredProperties != undefined ? { ...capturedConfiguredProperties } : (this.properties || {});
      // this.properties.datalabelStyle = capturedSignificanceValue == "None" ? "default" : "sigChange";
      // this.properties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.properties.datalabelStyle;
      if (this.hasCustomMetricSignificance) {
        this.properties.datalabelStyle = "default";
      } else {
        this.properties.datalabelStyle =
          capturedSignificanceValue == "None"
            ? "default"
            : "sigChange";
      }

      
      if (
        this._configService.isIndexSelected &&
        !this.hasCustomMetricIndex
      ) {
        this.properties.datalabelStyle = "index";
      }
      this.Sig_LowerLimt = this.significanceService.getSigLowerLimit(capturedDefaultConfidenceLevel, true);
      this.Sig_UpperLimt = this.significanceService.getSigUpperLimit(capturedDefaultConfidenceLevel, true);
      this.preparemainChartData(capturedCustomData);
      this.getData(this.jsonData, this.properties.datalabelStyle == "ls");
      this.getBarChart('chart-container' + this.id, this.seriesData1, this.properties);
    };

    // Fetch barData.json only ONCE (for the properties structure); subsequent calls render synchronously
    if (this.jsonData) {
      doRender();
    } else {
      this.updateSigSub = this.http.get<any>('assets/Data/barData.json').subscribe((data: any) => {
        this.jsonData = data;
        this.barChartData = data[0]["data"];
        doRender();
      });
    }
  }

  private shouldUseMetricAsCategory(data: any): boolean {
    const metricValues = data?.metric_value ?? [];
    if (metricValues.length > 1) {
      return true;
    }
    if (metricValues.length === 1) {
      const rowChildren = new Set(
        (metricValues[0].data ?? []).map((d: any) => d.rowChild).filter(Boolean)
      );
      return rowChildren.size > 1;
    }
    return false;
  }
  private get isMultiMarketSnapshot(): boolean {
    const snapshotType = (
      this._customSnapshotService.selectedSnapshotType?.name ||
      this._configService.selectedSnapshotType ||
      ''
    ).toLowerCase();
    return snapshotType.includes('multiple markets') || snapshotType.includes('multimarket');
  }

  private shouldUseBrandAsCategory(data: any): boolean {
    if (this.isMultiMarketSnapshot) {
      return true;
    }
    if (!this._configService.selectedcompareacrossOption?.includes('Multiple Brands')) {
      return false;
    }
    return !this.shouldUseMetricAsCategory(data);
  }

  private resolveMetricDisplayName(lev2: any, dataArr: any): string {
    const raw = lev2?.option?.trim() || (dataArr?.rowChild ?? lev2?.rowChild ?? '');
    const value = typeof raw === 'string' ? raw.trim() : '';
    if (!value) return '';
    if (!value.includes('|')) return value;
    const parts = value.split('|').map((p: string) => p.trim());
    const last = parts[parts.length - 1]?.toLowerCase();
    if (last === 'yes') {
      if (parts.length >= 3) return `${parts[parts.length - 3]} | ${parts[parts.length - 2]}`;
      return parts[0] || '';
    }
    if (parts.length >= 2) return `${parts[parts.length - 2]} | ${parts[parts.length - 1]}`;
    return parts[0] || '';
  }

  private resolveBrandDisplayName(dataArr: any): string {
    if (dataArr.colChild) {
      const parts = dataArr.colChild.split('|');
      return parts.length > 1 ? parts[parts.length - 1].trim() : dataArr.colChild;
    }
    const match = dataArr.rowVariableCode?.match(/_(\d+)$/);
    if (!match) {
      return '';
    }
    const brandIndex = parseInt(match[1], 10) - 1;
    const sortedBrands = [...(this._configService.brandSortId || [])].sort(
      (a: any, b: any) => a.sortId - b.sortId
    );
    return sortedBrands[brandIndex]?.name ?? '';
  }

  private getCategoryName(dataArr: any, lev2: any, data: any): string {
    if (this.shouldUseBrandAsCategory(data)) {
      return this.resolveBrandDisplayName(dataArr) || this.resolveMetricDisplayName(lev2, dataArr);
    }
    return this.resolveMetricDisplayName(lev2, dataArr);
  }

  transformRowChild(data: any[]): any[] {
    if (!data || data.length === 0) return data;

    return data.map(item => {
      return {
        ...item,
        data: item.data.map((d: any) => {
          const parts = d.rowChild
            ?.split('|')
            .map((p: string) => p.trim()) || [];

          if (parts.length === 0) return d;

          const last = parts[parts.length - 1]?.toLowerCase();
          let updatedRowChild = '';

          if (last === 'yes') {
            // Take two parts before "Yes"
            if (parts.length >= 3) {
              updatedRowChild = `${parts[parts.length - 3]} | ${parts[parts.length - 2]}`;
            } else {
              updatedRowChild = parts[0] || '';
            }
          } else {
            // For "no" and all other cases: take last two parts
            if (parts.length >= 2) {
              updatedRowChild = `${parts[parts.length - 2]} | ${parts[parts.length - 1]}`;
            } else {
              updatedRowChild = parts[0] || '';
            }
          }

          return {
            ...d,
            rowChild: updatedRowChild
          };
        })
      };
    });
  }

  preparemainChartData(data: any) {
    let i = 0;

    this.chartMainData = [];
    this.maxBarValue = 0;
    const transformedData = {
      ...data,
      metric_value: this.transformRowChild(data?.metric_value ?? []),
    };
    const useMetricCategory = this.shouldUseMetricAsCategory(transformedData);
    const multipleMetricGroups = (transformedData?.metric_value?.length ?? 0) > 1;

    transformedData.metric_value.forEach((lev2: any) => {
      let dataPoints = lev2.data ?? [];
      if (useMetricCategory && multipleMetricGroups) {
        dataPoints = dataPoints.length ? [dataPoints[0]] : [];
      }
      const hasPercentageExtension =
        lev2.extensionOptions?.some(
          (e: any) =>
            e.id === 'percentageSymbol' &&
            e.selected
        ) || false;
      dataPoints.forEach((dataArr: any) => {
        let d1 = {
          "Series Name": lev2.metric_group,
          "Category Name": this.getCategoryName(dataArr, lev2, transformedData),
          "Rounded Value": dataArr.data == null ? null : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
          //"Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
          "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
          "ValueForIndex": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
          "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
          "Label": dataArr.data == null ? "NA" : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
          "Change value vs PY": dataArr.changeVsPY,
          "Significance": "-1",
          "Sample size": dataArr.baseValueforLSorIs,
          "Significance2": "1",
          "XValue": ++i,
           "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
          // "isPercentage":
          //   hasPercentageExtension
          //     ? false
          //     : true,
          "Sig_LowerLimt": this.Sig_LowerLimt,
          "Sig_UpperLimt": this.Sig_UpperLimt,
          "Significance_Value": dataArr.Significance_Value,
          "color": dataArr.color,
          "colorLinearGradient": dataArr.colorLinearGradient
        }
        this.chartMainData.push(d1);
        if (!isNaN(d1["Rounded Value"])) {
          const rounded = Math.round(parseFloat(d1["Rounded Value"]) * 10) / 10;
          if (this.maxBarValue < rounded) {
            this.maxBarValue = rounded;
          }
        }
      });
    });
    if(this.configuredProperties){
      if(this.configuredProperties?.sort=="ascending"){
        const sortedData = this.chartMainData.sort((a:any, b:any) => {
          // Compare the "Value" field in ascending order
          if (a["Value"] === "NA" && b["Value"] === "NA") {
            return 0; // If both are "NA", keep them in the same order
          }
          if (a["Value"] === "NA") {
            return 1; // If a is "NA", place it after b
          }
          if (b["Value"] === "NA") {
            return -1; // If b is "NA", place it after a
          }

          // Otherwise, compare numerically (assuming "Value" is a number or can be coerced into a number)
          return a["Value"] - b["Value"];
        });
        this.chartMainData=sortedData;
      }
      if(this.configuredProperties?.sort=="descending"){
        const sortedDataDesc = this.chartMainData.sort((a:any, b:any) => {
          // Compare the "Value" field in descending order
          if (a["Value"] === "NA" && b["Value"] === "NA") {
            return 0; // If both are "NA", keep them in the same order
          }
          if (a["Value"] === "NA") {
            return -1; // If a is "NA", place it after b
          }
          if (b["Value"] === "NA") {
            return 1; // If b is "NA", place it after a
          }

          // Otherwise, compare numerically (assuming "Value" is a number or can be coerced into a number)
          return b["Value"] - a["Value"]; // For descending order, reverse the comparison
        });
        this.chartMainData=sortedDataDesc;
      }
    }
  }

  // getData(chartData: any, lowSample1: any) {
  //   let seriesData: any[] = [];
  //   let value = 0;
  //   let i = 0;
  //   let maxValue = 0;
  //   let minValue = 0;
  //   let j = 0;

  //   const firstItem = chartData[0].data[0]['Series Name'];

  //   const indiaData = _.cloneDeep(chartData[0].data.filter((item: { [x: string]: string }) => item['Series Name'] === firstItem));
  //   this.categoryImages = chartData[0].data.map((item: { [x: string]: string }) => (item["Category Image"]));
  //   let catc = this.categoryImages.length - 1;
  //   this.categoryImages = [''].concat(this.categoryImages);

  //   let c = this.categoryImages.length;
  //   maxValue = Math.max(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
  //   minValue = Math.min(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
  //   this.max = maxValue + Math.ceil(maxValue * 0.10);
  //   this.min = minValue + Math.ceil(minValue * 0.10);

  //   this.seriesData1 = indiaData.map((item: { [x: string]: string }) => ({

  //     value: item['Value'] == null ? 0 : parseFloat(Number(item["Value"]).toFixed(this.properties.decimalRoundOff)),
  //     numericValue: !lowSample1 ? value : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? value : 0),
  //     name: item['Category Name'],

  //     color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[catc--]) : this.properties.gradientBarColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],

  //     visible: true,
  //     zIndex: 2,
  //     type: 'bar',
  //     dataLabels: {

  //       borderWidth: 0,

  //     },
  //     data: [{
  //       name: item['Category Name'],
  //       y: !lowSample1 ? item['Value'] == null ? 0 : parseFloat(Number(item["Value"]).toFixed(this.properties.decimalRoundOff)) : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['Value'] == null ? 0 : parseFloat(Number(item["Value"]).toFixed(this.properties.decimalRoundOff)) : 0),
  //       x: parseInt(item['XValue']),
  //       seriesName: item['Series Name'],

  //     }],
  //     changeValueSeries: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Change value vs PY"])),
  //     significance: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance"])),
  //     significance2: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance2"])),
  //     sampleSize: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Sample size"])),
  //     roundedValue: indiaData.map((item: { [x: string]: string }) => parseFloat(Number(item["Value"]).toFixed(this.properties.decimalRoundOff))),
  //     tooltip: [],

  //   }));


  //   this.labels = indiaData.map((item: { [x: string]: string }) => parseFloat(item["Label"]));

  //   this.categories = Array.from(new Set(indiaData.map((item: { [x: string]: string }) => item['Category Name'])));
  //   this.categories = [''].concat(Array.from(new Set(indiaData.map((item: { [x: string]: string }) => item['Category Name']))));



  //   indiaData.forEach((item: { [x: string]: string }, index: number) => {


  //     let markerStyle = this.properties.markerStyle;
  //     let offsetMultiplier = 0.018;
  //     // Change marker style to triangle if 'Value' is negative and marker style is 'triangle'
  //     if (parseFloat(item['Value']) < 0 && markerStyle === 'triangle') {
  //       markerStyle = 'triangle-down'; // Or whatever style you want to use for negative values
  //     }
  //     if (parseFloat(item['Value']) < 50 && parseFloat(item['Value']) > 0) {
  //       offsetMultiplier = 0.045; // Further increase offset if value is less than 50
  //     }
  //     if (parseFloat(item['Value']) <= 70 && parseFloat(item['Value']) >= 50 && parseFloat(item['Value']) > 0) {
  //       offsetMultiplier = 0.03; // Increase offset if value is less than or equal to 80 and greater than 0
  //     }
  //     this.seriesData1.push({
  //       name: item['Category Name'],
  //       type: 'scatter',
  //       zIndex: 1,
  //       marker: {
  //         symbol: markerStyle,
  //         fillColor: 'red',
  //         lineColor: 'red',
  //         lineWidth: 2,
  //       },
  //       enableMouseTracking: false,
  //       showInLegend: false,
  //       visible: this.properties.marker == 'enable' ? true : false,
  //       data: [{
  //         name: item['Category Name'],
  //         y: !lowSample1 ? (item['Value'] == null || parseFloat(item['Value']) === 0) ? null :
  //           parseFloat(item['Value']) > 0 ? parseFloat(item['Value']) + (offsetMultiplier * parseFloat(item['Value'])) :
  //             parseFloat(item['Value']) + (0.02 * parseFloat(item['Value'])) :
  //           (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant && item['Value'] != null && parseFloat(item['Value']) !== 0) ?
  //             parseFloat(item['Value']) > 0 ? parseFloat(item['Value']) + (offsetMultiplier * parseFloat(item['Value'])) :
  //               parseFloat(item['Value']) + (0.02 * parseFloat(item['Value'])) : null,
  //         x: index + 1,
  //         z: parseFloat(item['Sample Size']) > this.barService.sampleSizeConstant ? 0 : item['Value'] == null ? 0 : parseFloat(item['Value']),
  //       }],
  //     });
  //   });



  // }
  getData(chartData: any, lowSample1: any) {
    if (this.isOutput) {
      // this.properties=this.configuredProperties!=undefined?this.configuredProperties:this.properties;
      let value = 0;
      let i = 0;
      let maxValue = 0;
      let minValue = 0;
      let j = 0;

      chartData[0].data = this.chartMainData
        .filter((item: any) => item['Label'] !== 'NA' && item['Label'] !== null)
        .map((item: any, idx: number) => ({ ...item, XValue: idx + 1 })); //extra added(req)

      if (chartData[0].data.length == 0) {
        this.seriesData1 = [];
        return;
      }

      const firstItem = chartData[0].data[0]['Series Name'];//extra added (req)

      const indiaData = chartData[0].data.filter((item: { [x: string]: string }) => item['Series Name'] === firstItem);
      this.categoryImages = chartData[0].data.map((item: { [x: string]: string }) => (item["Category Image"]));
      this.categoryImages = [''].concat(this.categoryImages);
      // Check if isPercentage - if not, set max=null and min=0; else max=100 and min=0
      const isPercentage = indiaData.length > 0 ? indiaData[0]['isPercentage'] : false;
      
      if (!isPercentage) {
        this.max = null;
        this.min = 0;
      } else {
        this.max = 100;
        this.min = 0;
      }
      // ;
      this.seriesData1 = indiaData.map((item: { [x: string]: string }) => {
        const plottedY = this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold
          ? 0
          : (!lowSample1
            ? item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff))
            : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant
              ? item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff))
              : 0));
        return ({

        value: (item['Value'] == null || item['Value'] == "NA") ? 0 : this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : parseFloat(item['Value']),
        numericValue: !lowSample1 ? value : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? value : 0),
        name: item['Category Name'],
        color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? item['colorLinearGradient'] : item['color'],
        //color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[j++]) : this.properties.gradientBarColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],
        visible: true,
        zIndex: 1,
        type: 'bar',
        dataLabels: {
          borderWidth: 0,
        },
        data: [{
          name: item['Category Name'],
          ispercent: item["isPercentage"],
          y: plottedY,
          x: parseInt(item['XValue']),
          seriesName: item['Series Name'],
          indexValue: this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : (!lowSample1 ? item['ValueForIndex'] == null ? 0 : Number(parseFloat(item['ValueForIndex']).toFixed(this.properties.decimalRoundOff)) : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['ValueForIndex'] == null ? 0 : Number(parseFloat(item['ValueForIndex']).toFixed(this.properties.decimalRoundOff)) : 0)),
          actualIndexValue: item['ActualIndexValue'],
          dataLabels: {
  // cap the configured offset so labels for near-100% bars stay within the chart's reserved marginRight, while still leaving a gap after the bar
  x: (this.properties.datalabelStyle == "default"
      ? Math.min(this.properties.dataLabel_y_positionHorizontal ?? 10, 20) + 8
      : Math.min(this.properties.dataLabel_y_positionHorizontal ?? 10, 20) + 11)
      * (plottedY < 0 ? -1 : 1),
            //x: (this.properties.datalabelStyle == "default" ? this.properties.dataLabel_y_positionHorizontal + 10 : this.properties.dataLabel_y_positionHorizontal + 20) * (plottedY < 0 ? -1 : 1),
           // x: (this.properties.datalabelStyle == "default" ? this.properties.dataLabel_y_positionHorizontal + 10 : this.properties.dataLabel_y_positionHorizontal + 20) * (plottedY < 0 ? -1 : 1) + (plottedY < 0 ? 18: 0),
            align: plottedY < 0
              ? (this.properties.dataLabelPosition == "middle" ? "center" : this.properties.dataLabelPosition == "top" ? "left" : "right")
              : (this.properties.dataLabelPosition == "middle" ? "center" : this.properties.dataLabelPosition == "top" ? "right" : "left")
          }
        }],
        changeValueSeries: indiaData.map((item: { [x: string]: string }) => (item["Change value vs PY"])),
        significance: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance"])),
        significance2: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance2"])),
        sampleSize: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Sample size"])),
        roundedValue: indiaData.map((item: { [x: string]: string }) => item["Rounded Value"]),

        //calculationTypes: indiaData.map((item: { [x: string]: string }) => item["CalculationType"]),

        tooltip: [],
        isPercentage: item["isPercentage"],
        Sig_LowerLimt: this.Sig_LowerLimt,
        Sig_UpperLimt: this.Sig_UpperLimt,
        Significance_Value: item["Significance_Value"],

      });
      });

      if (minValue >= 0)
        this.min = 0

      this.labels = indiaData.map((item: { [x: string]: string }) => parseFloat(item["Label"]));

      // this.categories = Array.from(new Set(indiaData.map((item: { [x: string]: string }) => item['Category Name'])));
      // this.categories = [''].concat(Array.from(new Set(indiaData.map((item: { [x: string]: string }) => item['Category Name']))));

      this.categories = Array.from(indiaData.map((item: { [x: string]: string }) => item['Category Name']));
      this.categories = [''].concat(Array.from(indiaData.map((item: { [x: string]: string }) => item['Category Name'])));



      indiaData.forEach((item: { [x: string]: string }, index: number) => {
        let markerStyle = this.properties.markerStyle;

        // Change marker style to triangle if 'Rounded Value' is negative and marker style is 'triangle'
        if (parseFloat(item['Rounded Value']) < 0 && markerStyle === 'triangle') {
          markerStyle = 'triangle-down'; // Or whatever style you want to use for negative values
        }
        this.seriesData1.push({
          name: item['Category Name'],
          type: 'scatter',
          zIndex: -999,
          marker: {
            symbol: markerStyle,
            fillColor: 'red',
            lineColor: 'red',
            lineWidth: 2,
          },
          enableMouseTracking: false,
          showInLegend: false,
          visible: this.properties.marker == 'enable' ? true : false,
          data: [{
            name: item['Category Name'],
            y: !lowSample1 ? item['Rounded Value'] == null ? null : parseFloat(item['Rounded Value']) == 0 ? null : parseFloat(item['Rounded Value']) + (0.02 * parseFloat(item['Rounded Value'])) : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['Rounded Value'] == null ? null : parseFloat(item['Rounded Value']) == 0 ? null : parseFloat(item['Rounded Value']) + (0.02 * parseFloat(item['Rounded Value'])) : null),

            x: index + 1,
            z: parseFloat(item['Sample Size']) > this.barService.sampleSizeConstant ? 0 : item['Rounded Value'] == null ? 0 : parseFloat(item['Rounded Value']),
            Sig_LowerLimt: this.Sig_LowerLimt,
            Sig_UpperLimt: this.Sig_UpperLimt,
            Significance_Value: item['Significance_Value']
          }],
        });
      });
    }
    else{
      let seriesData: any[] = [];
    let value = 0;
    let i = 0;
    let maxValue = 0;
    let minValue = 0;
    let j = 0;

    const firstItem = chartData[0].data[0]['Series Name'];

    const indiaData = _.cloneDeep(chartData[0].data.filter((item: { [x: string]: string }) => item['Series Name'] === firstItem));
    this.categoryImages = chartData[0].data.map((item: { [x: string]: string }) => (item["Category Image"]));
    let catc = this.categoryImages.length - 1;
    this.categoryImages = [''].concat(this.categoryImages);

    let c = this.categoryImages.length;
    
    // Check if isPercentage - if not, set max=null and min=0; else max=100 and min=0
    const isPercentageOld = indiaData.length > 0 ? indiaData[0]['isPercentage'] : false;
    
    if (!isPercentageOld) {
      this.max = null;
      this.min = 0;
    } else {
      this.max = 100;
      this.min = 0;
    }
    this.seriesData1 = indiaData.map((item: { [x: string]: string }) => {
	const plottedY = !lowSample1
        ? item['Value'] == null ? 0 : parseFloat(Number(item["Value"]).toFixed(this.properties.decimalRoundOff))
        : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant
          ? item['Value'] == null ? 0 : parseFloat(Number(item["Value"]).toFixed(this.properties.decimalRoundOff))
          : 0);
      return ({
      value: item['Value'] == null ? 0 : parseFloat(Number(item["Value"]).toFixed(this.properties.decimalRoundOff)),
      numericValue: !lowSample1 ? value : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? value : 0),
      name: item['Category Name'],
      color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? item['colorLinearGradient'] : item['color'],
      //color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[catc--]) : this.properties.gradientBarColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],
      visible: true,
      zIndex: 2,
      type: 'bar',
      dataLabels: {

        borderWidth: 0,

      },
      data: [{
        name: item['Category Name'],
        y: plottedY,
        x: parseInt(item['XValue']),
        seriesName: item['Series Name'],
        dataLabels: {
          // cap the configured offset so labels for near-100% bars stay within the chart's reserved marginRight, while still leaving a gap after the bar
          x: (this.properties.datalabelStyle == "default" ? Math.min(this.properties.dataLabel_y_positionHorizontal ?? 10, 20) + 8 : Math.min(this.properties.dataLabel_y_positionHorizontal ?? 10, 20) + 11) * (plottedY < 0 ? -1 : 1),
          align: plottedY < 0
            ? (this.properties.dataLabelPosition == "middle" ? "center" : this.properties.dataLabelPosition == "top" ? "left" : "right")
            : (this.properties.dataLabelPosition == "middle" ? "center" : this.properties.dataLabelPosition == "top" ? "right" : "left")
        }

      }],
      changeValueSeries: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Change value vs PY"])),
      significance: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance"])),
      significance2: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance2"])),
      sampleSize: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Sample size"])),
      roundedValue: indiaData.map((item: { [x: string]: string }) => parseFloat(Number(item["Value"]).toFixed(this.properties.decimalRoundOff))),
      tooltip: [],

    });
    });


    this.labels = indiaData.map((item: { [x: string]: string }) => parseFloat(item["Label"]));

    this.categories = Array.from(new Set(indiaData.map((item: { [x: string]: string }) => item['Category Name'])));
    this.categories = [''].concat(Array.from(new Set(indiaData.map((item: { [x: string]: string }) => item['Category Name']))));



    indiaData.forEach((item: { [x: string]: string }, index: number) => {


      let markerStyle = this.properties.markerStyle;
      let offsetMultiplier = 0.018;
      // Change marker style to triangle if 'Value' is negative and marker style is 'triangle'
      if (parseFloat(item['Value']) < 0 && markerStyle === 'triangle') {
        markerStyle = 'triangle-down'; // Or whatever style you want to use for negative values
      }
      if (parseFloat(item['Value']) < 50 && parseFloat(item['Value']) > 0) {
        offsetMultiplier = 0.045; // Further increase offset if value is less than 50
      }
      if (parseFloat(item['Value']) <= 70 && parseFloat(item['Value']) >= 50 && parseFloat(item['Value']) > 0) {
        offsetMultiplier = 0.03; // Increase offset if value is less than or equal to 80 and greater than 0
      }
      this.seriesData1.push({
        name: item['Category Name'],
        type: 'scatter',
        zIndex: 1,
        marker: {
          symbol: markerStyle,
          fillColor: 'red',
          lineColor: 'red',
          lineWidth: 2,
        },
        enableMouseTracking: false,
        showInLegend: false,
        visible: this.properties.marker == 'enable' ? true : false,
        data: [{
          name: item['Category Name'],
          y: !lowSample1 ? (item['Value'] == null || parseFloat(item['Value']) === 0) ? null :
            parseFloat(item['Value']) > 0 ? parseFloat(item['Value']) + (offsetMultiplier * parseFloat(item['Value'])) :
              parseFloat(item['Value']) + (0.02 * parseFloat(item['Value'])) :
            (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant && item['Value'] != null && parseFloat(item['Value']) !== 0) ?
              parseFloat(item['Value']) > 0 ? parseFloat(item['Value']) + (offsetMultiplier * parseFloat(item['Value'])) :
                parseFloat(item['Value']) + (0.02 * parseFloat(item['Value'])) : null,
          x: index + 1,
          z: parseFloat(item['Sample Size']) > this.barService.sampleSizeConstant ? 0 : item['Value'] == null ? 0 : parseFloat(item['Value']),
        }],
      });
    });
    }
  }

  patternselect(ispattern: boolean) {
    this.properties.showPattern = ispattern
    this.getData(this.jsonData, this.properties.datalabelStyle == "ls");
    this.getBarChart('chart-container' + this.id, this.seriesData1, this.properties);
    ;
  }
  getColor(): string {
    const color = this.barService.colors[this.barService.colorIndex];
    this.barService.colorIndex = (this.barService.colorIndex + 1) % this.barService.colors.length; // Cycle through colors
    return color;
  }
  getDataLabelY(numericValue: number): number {
    // Set the y value based on the sign of numericValue

    return numericValue > 0 ? (numericValue - 50) : -20;
  }

  customization(): Observable<any> {
    // return this.barService.HorizontalBarcustomizationList();
      const snapshotTypeSelectedName = this._customSnapshotService.selectedSnapshotType?.name;
    const cohortType = snapshotTypeSelectedName && snapshotTypeSelectedName.toLowerCase().includes('audience') 
      ? this._configService.audienceCohortType 
      : 'NA';
    return this._customSnapshotService.getChartCustomization("Horizontal Bar Chart", snapshotTypeSelectedName, cohortType);

  }

  // commonfunc(event: any, customization: string, options: any) {
  //   let property;
  //   this.event = event;
  //   this.barService.commonFunc(customization, event, this.properties)
  //   this.getData(this.jsonData, this.properties.datalabelStyle == "ls");
  //   this.getBarChart('chart-container'+this.id, this.seriesData1, this.properties);
  // }
  getBarChart(containerId: string, seriesData: any[], properties: any) {   
    if(this.isOutput){
    if (!seriesData || seriesData.length === 0) {
      const containerEl = document.getElementById(containerId);
      if (containerEl) {
        containerEl.innerHTML = '<div style="display:flex; align-items:center; justify-content:center; height:100%; min-height:100px; font-size: 0.7rem; font-family:KantarBrown-Regular,sans-serif;">Not Applicable</div>';
      }
      return;
    }
    localStorage.setItem("properties", JSON.stringify(this.properties));
    let labels = this.labels;
    let serviceBar = this.barService;
    const updatedCategories = this.categoryImages;


    const maxLabelCharacters = this.popUp ? 30 : 20; // Adjust the maximum number of characters as needed

    const defaultCategories = this.categories;
let popUp=this.popUp;

    const xAxisMax = this.popUp
      ? (this.seriesData1.length / 2 > this.maxDataPoints ? this.maxDataPoints : this.seriesData1.length / 2)
      : (this.seriesData1.length / 2 > 6 ? (this.properties.legendPosition == 'bottom' ? 4 : 6) : this.seriesData1.length / 2);
    const barCount = this.seriesData1.filter((s: any) => s.type === 'bar').length;
    const enableScrollbar = barCount > xAxisMax;

    const screenHeight = window.innerHeight; // Get the screen width

    // let height = '48%';
    // if (screenHeight <= 610) { // for 150% -> 593
    //   height = this.layoutNumber == 2 ? '55%' : '50%';
    // } else if (screenHeight <= 800) { // for 125% -> 738
    //   height = this.layoutNumber == 2 ? (this.popUp ? '50%' : '70%') : '50%';
    // } else if (screenHeight <= 1200) { //for 100% -> 953
    //   height = this.layoutNumber == 2 ? (this.popUp ? '50%' : '100%') : '50%';
    // }


    const configService = this._configService;
    this.properties.showLegend=false;
    properties=this.properties

    // Compute yAxisMin from actual plotted y values to support negative bars
    const yValues: number[] = seriesData
      .filter((s: any) => s.type === 'bar')
      .flatMap((s: any) => s.data.map((d: any) => d.y))
      .filter((v: any) => v !== null && v !== undefined && !isNaN(v));
    const computedMin = yValues.length > 0 ? Math.min(...yValues) : 0;
    const yAxisMin = computedMin < 0 ? computedMin * 1.1 : 0;
const computedMax = yValues.length > 0
  ? Math.max(...yValues)
  : 0;
    const options: Highcharts.Options = {
      chart: {
        type: 'bar',
        // marginRight: this.popUp ? 250 : 180,
        // extra room so data labels (e.g. "100%") aren't clipped when bars reach the axis max
        marginRight: this.popUp ? 72 : 62,
        // height: this.layoutNumber == 2 ? this.popUp ? height : this.height : height,
        backgroundColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
        style: {
          zIndex:1,
          overflow: 'visible',
          fontFamily: this.barService.textfont,
          color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
          // height:150,
          fontSize: "0.7rem"
        },
        events: {
          //to hide the marker along with the bar,when legend is click for each bar
          redraw: function (this: any) {
            // Adjust scatter series position after redrawing the chart
            var chart = this,
              series = chart.series;

            series.forEach(function (ser: any) {

              if (ser.type === 'column' && ser.type == 'scatter') {

                ser[1].forEach(function (scatter: any) {
                  scatter.setVisible(ser.visible, false);
                });
              }
            });
          },
          load: function () {
            const chart = this;
            if (!enableScrollbar) {
              const scrollEl = chart.container.querySelector('.highcharts-scrollbar') as HTMLElement | null;
              if (scrollEl) {
                scrollEl.style.display = 'none';
              }
              return;
            }
            //#region wheel scroll
            const container = chart.container;
            const xAxis = chart.xAxis[0];

            function onWheel(e: any) {
              e = e || window.event;
              e.preventDefault();

              // Normalize wheel delta
              let delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
              delta = delta > 0 ? -1 : 1; // reverse for natural scrolling

              const extremes = xAxis.getExtremes();
              const step = 1; // how many categories to scroll at a time

              let newMin = extremes.min + delta * step;
              let newMax = extremes.max + delta * step;

              // Bound checks
              if (newMin < extremes.dataMin) {
                newMin = extremes.dataMin;
                newMax = newMin + (extremes.max - extremes.min);
              }
              if (newMax > extremes.dataMax) {
                newMax = extremes.dataMax;
                newMin = newMax - (extremes.max - extremes.min);
              }

              xAxis.setExtremes(newMin, newMax, true, false);
            }

            container.addEventListener('wheel', onWheel, {
              passive: false,
            });
            //#endregion
          }
        }
      },

      title: {
        text: "",
        align: this.properties.chartTitlePosition,
        style: {
          color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
          marginleft: '4%',
          fontSize: '2em',
          fontFamily: this.barService.textfont
        },
      },
      subtitle: {


      },
      exporting: {
        enabled: false,
      },
      credits: {
        enabled: false
      },

      legend: this.barService.customizeLegend(this.chart, this.properties.showLegend, this.properties.legendPosition, this.properties,this.height),
      xAxis: {
        gridLineWidth: this.properties.xaxisgridlines ? 1 : 0,
        categories: defaultCategories,
        lineColor: '#A2A2A2', // Change to desired axis line color
        lineWidth: 1,
        min: 1,
        max: xAxisMax,
        scrollbar: {
          enabled: enableScrollbar,
          height: 6, // Adjust the height of the scrollbar as needed
          barBackgroundColor: '#7f7f7f',//#802AB7
          barBorderRadius: 5,
          barBorderWidth: 0,
          barBorderColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
          buttonBackgroundColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
          buttonBorderWidth: 0,
          buttonArrowColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
          buttonBorderRadius: 5,
          rifleColor: 'none',
          trackBackgroundColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
          trackBorderWidth: 0,
          trackBorderColor: 'black',
          trackBorderRadius: 5,

        },
        showEmpty: false,
        //labels: {
        //  useHTML: true,
        //  formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
        //    let labelContent = String(this.value);

        //    return '<span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; c + '">' + labelContent + '</span>';
        //  },
        //  rotation: this.barService.axisLabelOrientation(this.properties.axisLabelOrientation), // Rotate labels by desired angle
        //}
labels: {
            useHTML: true,
            style: {
              fontFamily: this.barService.textfont,
              // Add CSS styles for text overflow
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
            },
             formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
          // Calculate available width per label with responsive adjustments
          const chart = this.axis.chart;
          const categories = this.axis.categories || [];
          const chartWidth = chart.plotWidth || 400;
          const chartHeight = chart.plotHeight || 300;
          const numCategories = Math.max(categories.length - 1, 1);
          
          // Responsive calculations based on chart dimensions and device type
          const isSmallChart = chartWidth < 500 || chartHeight < 300;
          const isMediumChart = chartWidth >= 500 && chartWidth < 800;
          const isLargeChart = chartWidth >= 800;
          
          // Dynamic width calculations based on chart size and popup state
          let baseWidth = Math.floor(chartWidth / numCategories);
          let padding, minWidth, maxWidth;
          
        if (popUp) {
    // Popup mode - more generous spacing
    padding = isSmallChart ? 8 : isMediumChart ? 12 : 15;
    minWidth = isSmallChart ? 120 : isMediumChart ? 120 : 160;
    maxWidth = isSmallChart ? 200 : isMediumChart ? 250 : 300;
  } else {
    // Regular mode - tighter spacing
    padding = isSmallChart ? 4 : isMediumChart ? 6 : 8;
    minWidth = isSmallChart ? 150 : isMediumChart ? 100 : 150;
    maxWidth = isSmallChart ? 150 : isMediumChart ? 200 : 250;
  }
          
          const labelWidth = Math.min(Math.max(baseWidth - padding, minWidth), maxWidth);
        
          // Responsive text wrapping function
          function splitLabelToTwoLines(str: string, maxWidth: number) {
            // Dynamic character width estimation based on chart size
            const baseCharWidth = isSmallChart ? 5.5 : isMediumChart ? 6.0 : 6.5;
            const avgCharWidth = popUp ? baseCharWidth - 0.3 : baseCharWidth;
            const maxCharsPerLine = Math.floor(maxWidth / avgCharWidth);
            
            // Minimum characters per line to prevent overly narrow text
            const minCharsPerLine = isSmallChart ? 8 : 10;
            const effectiveMaxChars = Math.max(maxCharsPerLine, minCharsPerLine);
        
            const words = str.split(' ');
            let line1 = '';
            let line2 = '';
            let currentLine = '';
            let breakIndex = 0;
        
            // Build first line with word boundaries
            for (let i = 0; i < words.length; i++) {
              const testLine = currentLine ? currentLine + ' ' + words[i] : words[i];
              if (testLine.length <= effectiveMaxChars || !currentLine) {
                currentLine = testLine;
                breakIndex = i + 1;
              } else {
                break;
              }
            }
            line1 = currentLine;
        
            // Build second line with remaining words
            const remainingWords = words.slice(breakIndex);
            line2 = remainingWords.join(' ');
        
            // Truncate second line with ellipsis if needed
            if (line2.length > effectiveMaxChars) {
              const truncateAt = Math.max(effectiveMaxChars - 3, 5);
              line2 = line2.substring(0, truncateAt).trim() + '...';
            }
        
            return line2 ? `${line1}<br/>${line2}` : line1;
          }
        
          let labelContent = String(this.value);
          labelContent = splitLabelToTwoLines(labelContent, labelWidth);
        
          // Determine text alignment based on number of lines and chart size
          const isMultiLine = labelContent.includes('<br/>');
          const textAlign = 'right'; // Maintaining right alignment for horizontal bar chart
        
          // If axisImage is enabled, show image with responsive sizing
          if (properties.axisImage) {
            let index = categories.indexOf(String(this.value));
            const category1 = serviceBar.baseImgPath + updatedCategories[index] + '.png';
            if (category1) {
              const imageSize = isSmallChart ? '1.5em' : isMediumChart ? '2em' : '2.5em';
              return `<span style="display: inline-block; width: ${imageSize}; height: ${imageSize}; background: url(${category1}) no-repeat center center; background-size: cover;"></span>`;
            } else {
              return '<span>No Image</span>';
            }
          } else {
            // Responsive margin and font size adjustments
            const marginStyle = popUp ? 'margin: 0 2px' : 'margin: 0 auto';
            
            const lineHeight = isMultiLine ? (isSmallChart ? '1.1' : '1.2') : '1.3';
            
            return `<div style="width:${labelWidth}px; text-align: ${textAlign}; ${marginStyle}; padding: 0; line-height: ${lineHeight}; overflow: hidden;" title="${String(this.value)}">${labelContent}</div>`;
          }
        },


            overflow: 'justify', // Handle overflow with justification
            rotation: this.barService.axisLabelOrientation(this.properties.yaxisLabelOrientation), // Rotate labels by -90 degrees (or any other desired angle)
          }
      },

      yAxis: {

        max: yAxisMin < 0 ? computedMax * 1.15 : this.max,
        min: yAxisMin,
        plotLines: [{
          value: 0,
          width: 1
        }],
        tickInterval: this.getTickInterval(this.maxBarValue),
        gridLineWidth: this.properties.yaxisgridlines ? 1 : 0,


        labels: {
          enabled: false,
          format: this.properties.datalabelFormat == "percentage" ? '{value}%' : '{value}',
          style: {
            fontFamily: this.barService.textfont,
            color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
          },
        },
        title: {
          text: '', // Set an empty string to hide the yAxis title
        },
      },
            tooltip: {
        enabled: true,
        borderWidth: 1,
        useHTML: true,
       backgroundColor:  'white',  
        shadow: false,
       outside: true,
        style: {
           zIndex: 9999,
           backgroundColor: 'white',
          pointerEvents: 'none' // Prevent tooltip from interfering with mouse events
        },
         positioner: function (labelWidth: number, labelHeight: number, point: any) {
    // Show tooltip above the bar, or below if too close to the top
    let chart = this.chart;
    let y = point.plotY + chart.plotTop - labelHeight - 10; // 10px gap above
    if (y < chart.plotTop) {
      y = point.plotY + chart.plotTop + 10; // 10px gap below if not enough space above
    }
    // Center horizontally on the bar
    let x = chart.plotLeft + point.plotX - labelWidth / 2;
    // Prevent overflow left/right
    x = Math.max(chart.plotLeft, Math.min(x, chart.plotLeft + chart.plotWidth - labelWidth));
    return { x, y };
  },

        formatter: function (this: any) {
          //disable tootltip for marker
          if (this.series.name === 'Marker1') return false;
          //select tooltip style
          let isDefaultTooltip = properties.toolTipStyle;
          //tooltip border color
          const dotColor = this.color// Get the series color
          const backgroundcolor = properties.darkTheme ? '#f5f5f5' : '#b3b3b3';
          const backgroundcolor2 = properties.darkTheme ? 'white' : '#ddddd';
          //get the appropriate tooltip according to datalabel property selected
          const text = properties.showDataLabel ? this.series.userOptions.tooltip[this.point.x - 1] : this.y;

 
// if (isDefaultTooltip == 'style1') {
  const content =
    `<div class="high-z-tooltip" style="background: #fff;  min-width: 20px; font-size: 0.8em; display: flex; box-shadow: none;align-items: center;z-index:999 !important;">
      <span style=" width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
      <span>${this.point.name}: </span>
      <b style="margin-left:4px;">${text}</b>
    </div>`;
  return content;
// }
//       else {
//     const commonContent =
//               `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 2%; border-radius: 5px; margin: 0; background-color :${backgroundcolor2};z-index:999 !important;">` +
             
//               `<span><strong>Category Name:</strong></span> ${this.point.name}<br>` +
//               `<span><strong>Value:</strong></span> ${text}`;



//             return commonContent + '</div>';
// }

        },
      },

      plotOptions: {
        series: {
          clip: false,
          borderWidth: 0,
          animation: false,
          allowPointSelect: false,
          states: {
            hover: {
              enabled: false
            },
            inactive: {
              enabled: false
            },
            select: {
              enabled: false
            }
          },
          // animation: this.properties.dataLabelPositionPPT == 'Inside Base' || this.properties.dataLabelPositionPPT == 'Center' || this.properties.dataLabelPositionPPT == 'Inside End' || this.properties.dataLabelPositionPPT == 'Outside End' ? false : true,
          events: {
            //when a legend is clicked fro the bar,bar must disappear
            legendItemClick: function (this: any) {
              var series = this.chart.series,
                selectedSeriesName = this.name;

              // Loop through all series
              for (var i = 0; i < series.length; i++) {
                // Check if the series name matches the clicked legend's series name
                if (series[i].name === selectedSeriesName) {
                  // Toggle visibility of both bar and scatter series
                  series[i].setVisible(!series[i].visible, false);
                  if (series[i].type == 'scatter') {
                    series[i].scatterSeries.setVisible(!series[i].visible, false);
                  }
                }
              }

              // Redraw the chart
              this.chart.redraw();

              // Prevent default legend item click action
              return false;
            }
          }
        },
        bar: {
          pointPadding: 2,
          groupPadding: 3,
          grouping: false,
          stacking: undefined,
      
          shadow: this.properties.shadow ? {
            color: this.barService.shadowColor,
            offsetX: 1,
            offsetY: 1,
            opacity: 0.5,
            width: 6,
          } : false,
          pointWidth: 20,
        
          dataLabels: {

            style: {
              whiteSpace: 'normal',
              backgroundColor: this.barService.transparentBackground,
              textOutline: 'none',
              color: this.properties.darkTheme ? (this.properties.dataLabelColor === 'default' ? 'white' : this.properties.dataLabelColor || this.barService.darkThemeTextColor)
                : (this.properties.dataLabelColor === 'default'
                  ? 'black'
                  : this.properties.dataLabelColor || this.barService.defaultThemeTextColor),
              fontSize: this.properties.dataLabelSize,
              fontWeight: "normal",
              fontFamily: this.barService.textfont,
          
            },
            useHTML: true,
         
            overflow: 'allow',
            crop: false,
            enabled: this.properties.showDataLabel,

             inside: false,
  // x:properties.datalabelStyle == "default" ? properties.dataLabel_y_positionHorizontal+10 :  properties.dataLabel_y_positionHorizontal+20,
                       x: properties.datalabelStyle == "default"? 2: 5,
       
            y: this.properties.dataLabel_x_position,

            rotation: this.properties.datalabelOrientation,

            align: this.properties.dataLabelPosition == "middle" ? "center" : this.properties.dataLabelPosition == "top" ? "right" : "left",
            allowOverlap: true,

            formatter: function (this: any) {
              
              if (properties.datalabelStyle == "index") {

                let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (this.series.data[0].ispercent ? '%' : '') : serviceBar.nullValueText;
                // ;
                text = configService.CheckLSorIScondition(configService.userRole, text, this.series.userOptions.sampleSize[this.point.x - 1]);
                // this.series.userOptions.tooltip[this.point.x - 1] = text;
                // return (
                //   '<span >' + text + '</span>'
                // );



                // let text2 =
                //   this.series.userOptions.roundedValue[this.point.x - 1] === 0
                //     ? serviceBar.nullValueText
                //     : (this.series.userOptions.roundedValue[this.point.x - 1] == -1
                //       ? -1
                //       : ((this.series.userOptions.roundedValue[this.point.x - 1] != null)
                //         ? this.point.indexValue
                //         : serviceBar.nullValueText));
                let text2 =
                  this.point.actualIndexValue == null
                    ? serviceBar.nullValueText
                    : (this.series.userOptions.roundedValue[this.point.x - 1] == -1
                      ? -1
                      : ((this.series.userOptions.roundedValue[this.point.x - 1] != null)
                        ? this.point.indexValue
                        : serviceBar.nullValueText));
                if (text2 == "-1" || text2 == -1) {
                  text2 = "NA";
                }
                text2 = configService.CheckLSorIScondition(configService.userRole, text2, this.series.userOptions.sampleSize[this.point.x - 1]);


                let color = configService.CheckIndexColoring(text2);
                //// ;
                this.series.userOptions.tooltip[this.point.x - 1] = text + "(" + text2 + ")";
                return (
                  '<span style="font-size:0.5rem;">' + text + '</span><br>' +
                  '<span style="color:' + color + ';font-size:0.45rem;">' + " " + '(' + text2 + ')</span>'
                );
              }

              if (properties.datalabelStyle == "significance + changeVs") {

                let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                let changeText = this.series.userOptions.changeValueSeries[this.point.x - 1];
                let sig = this.series.userOptions.significance[this.point.x - 1];
                let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                if (parseFloat(changeText) > 0) {
                  changeText = "+" + changeText;
                }
                let finalText = '<span>' +
                  '<span>' + text
                  //+
                  + '</span>' +
                  (this.series.userOptions.roundedValue[this.point.x - 1] != null && changeText != null ? '<span>&nbsp' +
                    '<span style="font-size: ' + serviceBar.changeValueFontSize + ';color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + '; ">(' + changeText + ')</span>&nbsp;' +
                    '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
                  '</span>';
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                return (
                  finalText
                );


              }
              if (properties.datalabelStyle == "sigChange") {

                let changeText = this.series.userOptions.isPercentage ? (this.series.userOptions.changeValueSeries[this.point.x - 1]) * 100 :
                  this.series.userOptions.changeValueSeries[this.point.x - 1];
                let textCheck = configService.CheckLSorIScondition(configService.userRole, this.y, this.series.userOptions.sampleSize[this.point.x - 1]);
                let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? textCheck + (this.series.userOptions.isPercentage && (textCheck != 'I/S') ? '%' : '') : serviceBar.nullValueText;

                let sig = this.series.userOptions.significance[this.point.x - 1];
                let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                let sigClass = this.series.userOptions.Significance_Value < this.series.userOptions.Sig_LowerLimt ? 'red' : this.series.userOptions.Significance_Value > this.series.userOptions.Sig_UpperLimt ? 'green' : 'black';

                // if (parseFloat(changeText) > 0) {
                //   changeText = "+" + changeText;
                // }
                if (this.series.userOptions.changeValueSeries[this.point.x - 1] == null || this.series.userOptions.changeValueSeries[this.point.x - 1] == 'NA') {
                  let finalText = '<span>' +
                    '<span>' + text
                    //+
                    + '</span>' +
                    (this.series.userOptions.roundedValue[this.point.x - 1] != null ? '<span>&nbsp<br>' +
                      '<span style="color:black;font-size: ' + serviceBar.changeValueFontSize + '; "> (NA)</span>'
                      : '') +
                    '</span>';
                    let toolTipText='<span>' +
                    '<span>' + text
                    //+
                    + '</span>' +
                    (this.series.userOptions.roundedValue[this.point.x - 1] != null ? '<span>&nbsp' +
                      '<span style="color:black;font-size: ' + serviceBar.changeValueFontSize + '; "> (NA)</span>'
                      : '') +
                    '</span>';
                  this.series.userOptions.tooltip[this.point.x - 1] = toolTipText;

                  return (
                    finalText
                  );
                }
                else {
                  let finalText = '<span>' +
                    '<span>' + text
                    //+
                    + '</span>' +
                    (this.series.userOptions.Significance_Value == 0 ?
                      '<span style="color:' + sigClass + '; font-size: ' + serviceBar.changeValueFontSize + ';">(' + (this.series.userOptions.Significance_Value + (this.series.userOptions.isPercentage ? '%' : '')) + ')' + '</span>'
                      :
                    ((this.series.userOptions.roundedValue[this.point.x - 1] != null && changeText != null && textCheck != 'I/S') ? '<span>&nbsp<br>' +
                      '<span style="color:' + sigClass + '; font-size: ' + serviceBar.changeValueFontSize + ';">(' + (parseFloat(Number(changeText).toFixed(1)) + (this.series.userOptions.isPercentage ? '%' : '')) + ')' + '</span>'
                      : '')) +
                    '</span>';
                    let toolTipText='<span>' +
                    '<span>' + text
                    //+
                    + '</span>' +

                    (this.series.userOptions.Significance_Value == 0 ?
                       '<span style="color:' + sigClass + '; font-size: ' + serviceBar.changeValueFontSize + ';">(' + (this.series.userOptions.Significance_Value  + (this.series.userOptions.isPercentage ? '%' : '')) + ')' + '</span>'
                      :
                    ((this.series.userOptions.roundedValue[this.point.x - 1] != null && changeText != null && textCheck != 'I/S') ? '<span>&nbsp' +
                      '<span style="color:' + sigClass + '; font-size: ' + serviceBar.changeValueFontSize + ';">(' + (parseFloat(Number(changeText).toFixed(1)) + (this.series.userOptions.isPercentage ? '%' : '')) + ')' + '</span>'
                      : '')) +
                    '</span>';

                  this.series.userOptions.tooltip[this.point.x - 1] = toolTipText;

                  return (
                    finalText
                  );
                }

              }
              if (properties.datalabelStyle == "change") {

                let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                let changeText = this.series.userOptions.changeValueSeries[this.point.x - 1];
                if (parseFloat(changeText) > 0) {
                  changeText = "+" + changeText;
                }
                let finalText = '<span>' + text + "  " +
                  (this.series.userOptions.roundedValue[this.point.x - 1] != null && changeText != null ? '<span>&nbsp' +
                    '<span style="font-size: ' + serviceBar.changeValueFontSize + ';color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + '; ">(' + changeText + ')</span>&nbsp;' +
                    '</span>' : '');

                this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                return (
                  finalText
                );

              }

              if (properties.datalabelStyle == "ls") {


                let text = parseFloat(this.series.userOptions.sampleSize[this.point.x - 1]) > serviceBar.sampleSizeConstant ? this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText : serviceBar.lowSampleText;
                let finalText = '<b>' +
                  text +
                  '</b> ' +
                  '<span style="opacity: 0.5"></span>';
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                return finalText;
              }
              if (properties.datalabelStyle == "significance") {
                let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                let sig = this.series.userOptions.significance[this.point.x - 1];
                let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                let finalText = '<span >' + text + (this.series.userOptions.roundedValue[this.point.x - 1] != null ? '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span>' : '') + '</span>';
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                return (
                  finalText
                )

              }
              if (properties.datalabelStyle == "default") {

                let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (this.series.data[0].ispercent ? '%' : '') : serviceBar.nullValueText;
                // ;
                text = configService.CheckLSorIScondition(configService.userRole, text, this.series.userOptions.sampleSize[this.point.x - 1]);
                this.series.userOptions.tooltip[this.point.x - 1] = text;
                return (
                  '<span >' + text + '</span>'
                );
              }
              if (properties.datalabelStyle == "datalabel") {
                let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                this.series.userOptions.tooltip[this.point.x - 1] = text;
                return (
                  '<span >' + text + '</span>'
                );
              }

              if (properties.datalabelStyle == "significance2") {
                let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                let changeText = this.series.userOptions.changeValueSeries[this.point.x - 1];
                let sig = this.series.userOptions.significance[this.point.x - 1];
                let sig1 = this.series.userOptions.significance2[this.point.x - 1];
                let sColor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                let changeColor = sig1 < 0 ? serviceBar.lowSignificance : (sig1 > 0 ? serviceBar.highSignificance : properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor);


                if (parseFloat(changeText) > 0) {
                  changeText = "+" + changeText;
                }
                let finalText = '<span>' + text +
                  (this.series.userOptions.roundedValue[this.point.x - 1] != null && changeText != null ? '&nbsp<span style="color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + ' "> ' +
                    '<span style="font-size:' + serviceBar.changeValueFontSize + '; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                    '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                  '</span>';
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                return (
                  finalText
                );
              }

              return this.y != 0 ? this.y : serviceBar.nullValueText;

            },
          },
        },
      },
      series: this.properties.top10?seriesData.splice(0,10) :seriesData,


    }
    const containerEl = document.getElementById('chart-container' + this.id);
    if (!containerEl) { return; }
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
    this.chart = Highcharts.chart(containerEl, options);

    // let object = {
    //   chartType: "horizontal bar chart",
    //   widgetName: this.WidgetDetails.widgetName,
    //   widgetNumber: this.WidgetDetails.widgetNumber,
    //   pageNumber: this.pageNumber,
    //   data: this.chartMainData,
    //   properties: this.properties,
    //   selectionSummary: this._configService.selectionSummaryTextTitle,
    //   LSthreshold: this._configService.LBthreshold,
    //   ISthreshold: this._configService.ISthreshold,
    //   conversionPercentage: [],
    //   MDSdata: []
    // };

    // this._configService.listOfPptChartObjects.push(object);
  }
  else{
    localStorage.setItem("properties", JSON.stringify(this.properties));
    this.getData(this.jsonData, this.properties.datalabelStyle == "ls");
    let labels = this.labels;
    let popUp=this.popUp;
    let serviceBar = this.barService;
    const updatedCategories = this.categoryImages;
    const defaultCategories = this.categories;
    const containerEl = document.getElementById(containerId);
    if (!containerEl) { return; }
    this.chart = Highcharts.chart(containerEl, {
      chart: {
        type: 'bar',

        backgroundColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
        style: {
          fontFamily: this.barService.textfont,
          color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
        },
        events: {
          //to hide the marker along with the bar,when legend is click for each bar
          redraw: function (this: any) {
            // Adjust scatter series position after redrawing the chart
            var chart = this,
              series = chart.series;

            series.forEach(function (ser: any) {
              if (ser.type === 'column' && ser.type == 'scatter') {

                ser[1].forEach(function (scatter: any) {
                  scatter.setVisible(ser.visible, false);
                });
              }
            });
          },
          load: function () {
            const chart = this;
            // window.addEventListener('resize', function () {
            //   chart.reflow();
            // });
            //#region wheel scroll
            const container = chart.container;
            const xAxis = chart.xAxis[0];

            function onWheel(e: any) {
              e = e || window.event;
              e.preventDefault();

              // Normalize wheel delta
              let delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
              delta = delta > 0 ? -1 : 1; // reverse for natural scrolling

              const extremes = xAxis.getExtremes();
              const step = 1; // how many categories to scroll at a time

              let newMin = extremes.min + delta * step;
              let newMax = extremes.max + delta * step;

              // Bound checks
              if (newMin < extremes.dataMin) {
                newMin = extremes.dataMin;
                newMax = newMin + (extremes.max - extremes.min);
              }
              if (newMax > extremes.dataMax) {
                newMax = extremes.dataMax;
                newMin = newMax - (extremes.max - extremes.min);
              }

              xAxis.setExtremes(newMin, newMax, true, false);
            }

            container.addEventListener('wheel', onWheel, {
              passive: false,
            });
            //#endregion
          }
        }
      },

      title: {
        text: "",
        align: this.properties.chartTitlePosition,
        style: {
          color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
          marginleft: '4%',
          fontSize: '2em',
          fontFamily: this.barService.textfont
        },
      },
      subtitle: {


      },
      exporting: {
        enabled: false,
      },
      credits: {
        enabled: false
      },

      //legend: this.barService.customizeLegend(this.chart, this.properties.showLegend, this.properties.legendPosition, this.properties,this.height),
      legend : {
        enabled : false,
      },
      xAxis: {

        categories: defaultCategories,

        min: 1,
        max: this.maxDataPoints,
        scrollbar: {
          enabled: defaultCategories.length > 4,
          height: 6, // Adjust the height of the scrollbar as needed
          barBackgroundColor: '#0060FF',
          barBorderRadius: 5,
          barBorderWidth: 0,
          barBorderColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
          buttonBackgroundColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
          buttonBorderWidth: 0,
          buttonArrowColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
          buttonBorderRadius: 5,
          rifleColor: 'none',
          trackBackgroundColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
          trackBorderWidth: 0,
          trackBorderColor: 'black',
          trackBorderRadius: 5,

        },
        showEmpty: false,
        //labels: {
        //  useHTML: true,
        //  formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
        //    let labelContent = String(this.value);

        //    return '<span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; c + '">' + labelContent + '</span>';
        //  },
        //  rotation: this.barService.axisLabelOrientation(this.properties.axisLabelOrientation), // Rotate labels by desired angle
        //}

       labels: {
       //x-axis labels styles
       useHTML: true,
       // y: xAxisyLabelPosition,
       style: {
         fontFamily: this.barService.textfont,
         color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
         whiteSpace: 'normal',
       },
     formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
  // Calculate available width per label with responsive adjustments
  const chart = this.axis.chart;
  const categories = this.axis.categories || [];
  const chartWidth = chart.plotWidth || 400;
  const chartHeight = chart.plotHeight || 300;
  const numCategories = Math.max(categories.length - 1, 1);
  
  // Responsive calculations based on chart dimensions and device type
  const isSmallChart = chartWidth < 500 || chartHeight < 300;
  const isMediumChart = chartWidth >= 500 && chartWidth < 800;
  const isLargeChart = chartWidth >= 800;
  
  // Dynamic width calculations based on chart size and popup state
  let baseWidth = Math.floor(chartWidth / numCategories);
  let padding, minWidth, maxWidth;
  
  if (popUp) {
    // Popup mode - more generous spacing
    padding = isSmallChart ? 8 : isMediumChart ? 12 : 15;
    minWidth = isSmallChart ? 1200 : isMediumChart ? 120 : 160;
    maxWidth = isSmallChart ? 200 : isMediumChart ? 250 : 300;
  } else {
    // Regular mode - tighter spacing
    padding = isSmallChart ? 4 : isMediumChart ? 6 : 8;
    minWidth = isSmallChart ? 150 : isMediumChart ? 100 : 150;
    maxWidth = isSmallChart ? 150 : isMediumChart ? 200 : 250;
  }
  
  const labelWidth = Math.min(Math.max(baseWidth - padding, minWidth), maxWidth);

  // Responsive text wrapping function
  function splitLabelToTwoLines(str: string, maxWidth: number) {
    // Dynamic character width estimation based on chart size
    const baseCharWidth = isSmallChart ? 5.5 : isMediumChart ? 6.0 : 6.5;
    const avgCharWidth = popUp ? baseCharWidth - 0.3 : baseCharWidth;
    const maxCharsPerLine = Math.floor(maxWidth / avgCharWidth);
    
    // Minimum characters per line to prevent overly narrow text
    const minCharsPerLine = isSmallChart ? 8 : 10;
    const effectiveMaxChars = Math.max(maxCharsPerLine, minCharsPerLine);

    const words = str.split(' ');
    let line1 = '';
    let line2 = '';
    let currentLine = '';
    let breakIndex = 0;

    // Build first line with word boundaries
    for (let i = 0; i < words.length; i++) {
      const testLine = currentLine ? currentLine + ' ' + words[i] : words[i];
      if (testLine.length <= effectiveMaxChars || !currentLine) {
        currentLine = testLine;
        breakIndex = i + 1;
      } else {
        break;
      }
    }
    line1 = currentLine;

    // Build second line with remaining words
    const remainingWords = words.slice(breakIndex);
    line2 = remainingWords.join(' ');

    // Truncate second line with ellipsis if needed
    if (line2.length > effectiveMaxChars) {
      const truncateAt = Math.max(effectiveMaxChars - 3, 5);
      line2 = line2.substring(0, truncateAt).trim() + '...';
    }

    return line2 ? `${line1}<br/>${line2}` : line1;
  }

  let labelContent = String(this.value);
  labelContent = splitLabelToTwoLines(labelContent, labelWidth);

  // Determine text alignment based on number of lines and chart size
  const isMultiLine = labelContent.includes('<br/>');
  const textAlign = 'right'; // Maintaining right alignment for horizontal bar chart

  // If axisImage is enabled, show image with responsive sizing
  if (properties.axisImage) {
    let index = categories.indexOf(String(this.value));
    const category1 = serviceBar.baseImgPath + updatedCategories[index] + '.png';
    if (category1) {
      const imageSize = isSmallChart ? '1.5em' : isMediumChart ? '2em' : '2.5em';
      return `<span style="display: inline-block; width: ${imageSize}; height: ${imageSize}; background: url(${category1}) no-repeat center center; background-size: cover;"></span>`;
    } else {
      return '<span>No Image</span>';
    }
  } else {
    // Responsive margin and font size adjustments
    const marginStyle = popUp ? 'margin: 0 2px' : 'margin: 0 auto';
    
    const lineHeight = isMultiLine ? (isSmallChart ? '1.1' : '1.2') : '1.3';
    
    return `<div style="width:${labelWidth}px; text-align: ${textAlign}; ${marginStyle}; padding: 0; line-height: ${lineHeight}; overflow: hidden;" title="${String(this.value)}">${labelContent}</div>`;
  }
},
       rotation: this.barService.axisLabelOrientation(this.properties.axisLabelOrientation),
     },
      },

      yAxis: {

        max: this.max,
        min: this.min,
        plotLines: [{
          value: 0,
          width: 1
        }],

        gridLineWidth: this.properties.gridlines ? 1 : 0,
        tickInterval: 50,

        labels: {
          enabled: false,
          // Rotate labels by -90 degrees (or any other desired angle)
          format: this.properties.datalabelFormat == "percentage" ? '{value}%' : '{value}',
          style: {
            fontFamily: this.barService.textfont,
            color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
          },
        },
        title: {
          text: '', // Set an empty string to hide the yAxis title
        },
      },
            tooltip: {
        enabled: true,
        borderWidth: 1,
        useHTML: true,
       backgroundColor:  'white',  
        shadow: false,
       outside: true,
        style: {
           zIndex: 9999,
           backgroundColor: 'white',
          pointerEvents: 'none' // Prevent tooltip from interfering with mouse events
        },
         positioner: function (labelWidth: number, labelHeight: number, point: any) {
    // Show tooltip above the bar, or below if too close to the top
    let chart = this.chart;
    let y = point.plotY + chart.plotTop - labelHeight - 10; // 10px gap above
    if (y < chart.plotTop) {
      y = point.plotY + chart.plotTop + 10; // 10px gap below if not enough space above
    }
    // Center horizontally on the bar
    let x = chart.plotLeft + point.plotX - labelWidth / 2;
    // Prevent overflow left/right
    x = Math.max(chart.plotLeft, Math.min(x, chart.plotLeft + chart.plotWidth - labelWidth));
    return { x, y };
  },

        formatter: function (this: any) {
          //disable tootltip for marker
          if (this.series.name === 'Marker1') return false;
          //select tooltip style
          let isDefaultTooltip = properties.toolTipStyle;
          //tooltip border color
          const dotColor = this.color// Get the series color
          const backgroundcolor = properties.darkTheme ? '#f5f5f5' : '#b3b3b3';
          const backgroundcolor2 = properties.darkTheme ? 'white' : '#ddddd';
          //get the appropriate tooltip according to datalabel property selected
          const text = properties.showDataLabel ? this.series.userOptions.tooltip[this.point.x - 1] : this.y;

 
if (isDefaultTooltip == 'style1') {
  const content =
    `<div class="high-z-tooltip" style="background: #fff;  min-width: 220px; font-size: 0.8em; display: flex; box-shadow: none;align-items: center;z-index:999 !important;">
      <span style=" width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
      <span>${this.point.name}: </span>
      <b style="margin-left:4px;">${text}</b>
    </div>`;
  return content;
}
      else {
    const commonContent =
              `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 2%; border-radius: 5px; margin: 0; background-color :${backgroundcolor2};z-index:999 !important;">` +
             
              `<span><strong>Category Name:</strong></span> ${this.point.name}<br>` +
              `<span><strong>Value:</strong></span> ${text}`;



            return commonContent + '</div>';
}

        },
      },

      plotOptions: {
        series: {
          borderWidth: 0,
          animation: false,
          // animation: this.properties.dataLabelPositionPPT == 'Inside Base' || this.properties.dataLabelPositionPPT == 'Center' || this.properties.dataLabelPositionPPT == 'Inside End' || this.properties.dataLabelPositionPPT == 'Outside End' ? false : true,
          events: {
            //when a legend is clicked fro the bar,bar must disappear
            legendItemClick: function (this: any) {
              var series = this.chart.series,
                selectedSeriesName = this.name;

              // Loop through all series
              for (var i = 0; i < series.length; i++) {
                // Check if the series name matches the clicked legend's series name
                if (series[i].name === selectedSeriesName) {
                  // Toggle visibility of both bar and scatter series
                  series[i].setVisible(!series[i].visible, false);
                  if (series[i].type == 'scatter') {
                    series[i].scatterSeries.setVisible(!series[i].visible, false);
                  }
                }
              }

              // Redraw the chart
              this.chart.redraw();

              // Prevent default legend item click action
              return false;
            }
          }
        },
        bar: {
          pointPadding: 2,
          groupPadding: 3,
          grouping: false,
          stacking: undefined,
         styles: {
            zIndex: 1,
          },
          shadow: this.properties.shadow ? {
            // color: this.properties.darkTheme ? this.barService.shadowDarkThme : this.barService.shadowColor,
            offsetX: 1,
            offsetY: 1,
            opacity: 0.5,
            width: 6,
          } : false,
          pointWidth: 20,

          dataLabels: {

            style: {

              backgroundColor: this.barService.transparentBackground,
                zIndex: 1,
              textOutline: 'none',

              color: this.properties.darkTheme ? (this.properties.dataLabelColor === 'default' ? 'white' : this.properties.dataLabelColor || this.barService.darkThemeTextColor)
                : (this.properties.dataLabelColor === 'default'
                  ? 'black'
                  : this.properties.dataLabelColor || this.barService.defaultThemeTextColor),
              fontSize: this.properties.dataLabelSize,
              fontWeight: "normal",
              fontFamily: this.barService.textfont,
            },

            overflow: 'allow',
            crop: false,
            enabled: this.properties.showDataLabel,

            inside: false,
            x:properties.datalabelStyle == "default" ? properties.dataLabel_y_positionHorizontal+10 :  properties.dataLabel_y_positionHorizontal+20,
              // x: this.properties.dataLabel_y_positionHorizontal+20,
                y: this.properties.dataLabel_x_position,
            rotation: this.properties.datalabelOrientation,

            align: this.properties.dataLabelPosition == "middle" ? "center" : this.properties.dataLabelPosition == "top" ? "right" : "left",
            allowOverlap: true,

            formatter: function (this: any) {


              if (properties.datalabelStyle == "significance + changeVs") {

                let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                let changeText = this.series.userOptions.changeValueSeries[this.point.x - 1];
                let sig = this.series.userOptions.significance[this.point.x - 1];
                let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                if (parseFloat(changeText) > 0) {
                  changeText = "+" + changeText;
                }
                let finalText = '<span>' +
                  '<span>' + text + '</span>' +
                  (this.series.userOptions.roundedValue[this.point.x - 1] != null && changeText != null ? '<span>&nbsp' +
                    '<span style="font-size: ' + serviceBar.changeValueFontSize + ';color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + '; ">(' + changeText + ')</span>&nbsp;' +
                    '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
                  '</span>';

                this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                return (
                  finalText
                );


              }
              if (properties.datalabelStyle == "change") {

                let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                let changeText = this.series.userOptions.changeValueSeries[this.point.x - 1];
                if (parseFloat(changeText) > 0) {
                  changeText = "+" + changeText;
                }
                let finalText = '<span>' + text + "  " +
                  (this.series.userOptions.roundedValue[this.point.x - 1] != null && changeText != null ? '<span>&nbsp' +
                    '<span style="font-size: ' + serviceBar.changeValueFontSize + ';color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + '; ">(' + changeText + ')</span>&nbsp;' +
                    '</span>' : '');
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                return (
                  finalText
                );

              }

              if (properties.datalabelStyle == "ls") {


                let text = parseFloat(this.series.userOptions.sampleSize[this.point.x - 1]) > serviceBar.sampleSizeConstant ? this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText : serviceBar.lowSampleText;
                let finalText =
                  text +

                  '<span style="opacity: 0.5"></span>';
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                return finalText;
              }
              if (properties.datalabelStyle == "significance") {
                let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                let sig = this.series.userOptions.significance[this.point.x - 1];
                let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                let finalText = '<span >' + text + (this.series.userOptions.roundedValue[this.point.x - 1] != null ? '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span>' : '') + '</span>';
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                return (
                  finalText
                )

              }
              if (properties.datalabelStyle == "default") {
                let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;

                this.series.userOptions.tooltip[this.point.x - 1] = text;
                return (
                  '<span >' + text + '</span>'
                );
              }
              if (properties.datalabelStyle == "datalabel") {
                let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                this.series.userOptions.tooltip[this.point.x - 1] = text;
                return (
                  '<span >' + text + '</span>'
                );
              }

              if (properties.datalabelStyle == "significance2") {
                let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                let changeText = this.series.userOptions.changeValueSeries[this.point.x - 1];
                let sig = this.series.userOptions.significance[this.point.x - 1];
                let sig1 = this.series.userOptions.significance2[this.point.x - 1];
                let sColor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                let changeColor = sig1 < 0 ? serviceBar.lowSignificance : (sig1 > 0 ? serviceBar.highSignificance : properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor);


                if (parseFloat(changeText) > 0) {
                  changeText = "+" + changeText;
                }
                let finalText = '<span>' + text +
                  (this.series.userOptions.roundedValue[this.point.x - 1] != null && changeText != null ? '&nbsp<span style="color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + ' "> ' +
                    '<span style="font-size:' + serviceBar.changeValueFontSize + '; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                    '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                  '</span>';
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                return (
                  finalText
                );
              }

              return this.y != 0 ? this.y : serviceBar.nullValueText;

            },
          },
        },
      },
      series: this.seriesData1,

    } as Highcharts.Options);
  }

  }

  userselectedproperties() {

    this.data["properties"][0] = this.properties;

    return JSON.stringify(this.data).toString();
  }

  index = -1;
  getPatternForImage(imageUrl: any) {
    return {
      pattern: {
        image: imageUrl,
        aspectRatio: 9 / 4
      }
    };
  }

  applycustomization(event: any, item: string) {
    this.event = event;
    //choose the appropriate customization
    this.barService.applycustomization(event, item, this.properties)
    this.getBarChart('chart-container' + this.id, this.seriesData1, this.properties);
  }

  getTickInterval(maxBarValue: number, precision: number = 0.05): number {
    if (maxBarValue <= 0) return 0.05;

    const desiredTickCount = 4;
    const rawInterval = maxBarValue / desiredTickCount;

    const step = 1 / precision;
    const rounded = Math.ceil(rawInterval * step) / step;

    return rounded + 0.01;
  }


  private updateSigSub: Subscription | null = null;

  ngOnDestroy(): void {
    if (this._updateSigTimer) {
      clearTimeout(this._updateSigTimer);
      this._updateSigTimer = null;
    }
    this.updateSigSub?.unsubscribe();
    this.subscriptions.unsubscribe();
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}
